import React from "react";
import { Container } from "./styles";

interface IProps {
  children: any;
  size?: number;
  // eslint-disable-next-line no-unused-vars
  onClick?(...params: any[]): void;
  disabled?: boolean;
  backgroundColor?: string;
  backgroundColorHover?: string;
}

const Button = ({
  children,
  size,
  onClick,
  backgroundColor,
  backgroundColorHover,
  disabled,
}: IProps) => (
  <Container
    size={size ?? 30}
    onClick={onClick}
    disabled={disabled}
    backgroundColor={backgroundColor}
    backgroundColorHover={backgroundColorHover}
  >
    {children}
  </Container>
);

export default Button;
